export default () => ({
  root: {
    width: '100%'
  }
})
